/**
 * @flow
 * @relayHash e12c4183fed5f0782952ebdee218dcf0
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type HomeOccurrenceQueryVariables = {||};
export type HomeOccurrenceQueryResponse = {|
  +viewer: ?{|
    +id: string
  |}
|};
export type HomeOccurrenceQuery = {|
  variables: HomeOccurrenceQueryVariables,
  response: HomeOccurrenceQueryResponse,
|};
*/


/*
query HomeOccurrenceQuery {
  viewer {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "viewer",
    "storageKey": null,
    "args": null,
    "concreteType": "Query",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "HomeOccurrenceQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "HomeOccurrenceQuery",
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "HomeOccurrenceQuery",
    "id": null,
    "text": "query HomeOccurrenceQuery {\n  viewer {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd307a429acb5fd023489b9c529f6aef5';
module.exports = node;
